<template>
  <div class="appealApproval">
    <h1>This is an appealApproval page</h1>
  </div>
</template>

<script>
export default {
  name: 'appealApproval',
  data () {
    return {
      arr1: [{
        'quarter': 'Q2',
        'kpi': '业务规划评级',
        'kpiType': 'Common'
      },
      { 'quarter': 'Q4',
        'kpi': '业务规划评级',
        'kpiType': 'Common' },
      { 'quarter': 'Q3',
        'kpi': '业务规划评级',
        'kpiType': 'Common' },
      {
        'quarter': 'Q2',
        'kpi': '业务规划评级1',
        'kpiType': 'Common'
      }
      ],
      arr2: [
        {
          'id': '01DB28DFD45E4B04A4A35F1C64648196',
          'versionName': '2021-医院渠道',
          'versionNameSub': '2021-医院渠道-Q2',
          'year': '2021',
          'channel': '医院渠道',
          'channelId': '0480436ACDA54134B4B55F6AEB20F6B5',
          'position': '医药代表',
          'positionId': 'D5A7841B964C46F4812A5FEF043A8326',
          'quarter': 'Q2',
          'kpi': '业务规划评级',
          'kpiWeight': '20.0',
          'kpiType': 'Common',
          'isCondition': null,
          'uploadState': null,
          'updateTime': '2021-09-10T16:45:53.097',
          'updateUser': '吴章强',
          'createTime': '2021-09-02T20:13:18.07',
          'createUser': '吴章强',
          'deployState': null,
          'kpiId': null,
          'kpiAchCondition': null
        },
        {
          'id': '1CEB0CA159FC4D97B164C3D739129D40',
          'versionName': '2021-医院渠道',
          'versionNameSub': '2021-医院渠道-Q1',
          'year': '2021',
          'channel': '医院渠道',
          'channelId': '0480436ACDA54134B4B55F6AEB20F6B5',
          'position': '医药代表',
          'positionId': 'D5A7841B964C46F4812A5FEF043A8326',
          'quarter': 'Q1',
          'kpi': '业务规划评级',
          'kpiWeight': '20.0',
          'kpiType': 'Common',
          'isCondition': null,
          'uploadState': null,
          'updateTime': '2021-09-10T16:45:53.097',
          'updateUser': '吴章强',
          'createTime': '2021-09-02T20:13:18.047',
          'createUser': '吴章强',
          'deployState': null,
          'kpiId': null,
          'kpiAchCondition': null
        },
        {
          'id': '2E4157B36B46466DA9509234F7B7F39D',
          'versionName': '2021-医院渠道',
          'versionNameSub': '2021-医院渠道-Q2',
          'year': '2021',
          'channel': '医院渠道',
          'channelId': '0480436ACDA54134B4B55F6AEB20F6B5',
          'position': '医药代表',
          'positionId': 'D5A7841B964C46F4812A5FEF043A8326',
          'quarter': 'Q2',
          'kpi': 'HT质量评级',
          'kpiWeight': '20.0',
          'kpiType': 'Common',
          'isCondition': null,
          'uploadState': null,
          'updateTime': '2021-09-10T13:36:06.063',
          'updateUser': '吴章强',
          'createTime': '2021-09-02T20:13:18.057',
          'createUser': '吴章强',
          'deployState': null,
          'kpiId': null,
          'kpiAchCondition': null
        },
        {
          'id': '4B395231FCE6496C85BD0104C82292CB',
          'versionName': '2021-医院渠道',
          'versionNameSub': '2021-医院渠道-Q1',
          'year': '2021',
          'channel': '医院渠道',
          'channelId': '0480436ACDA54134B4B55F6AEB20F6B5',
          'position': '医药代表',
          'positionId': 'D5A7841B964C46F4812A5FEF043A8326',
          'quarter': 'Q1',
          'kpi': '行为管理评级',
          'kpiWeight': '40.0',
          'kpiType': 'Common',
          'isCondition': null,
          'uploadState': null,
          'updateTime': '2021-09-10T13:36:06.063',
          'updateUser': '吴章强',
          'createTime': '2021-09-02T20:13:18.03',
          'createUser': '吴章强',
          'deployState': null,
          'kpiId': null,
          'kpiAchCondition': null
        },
        {
          'id': '8210FB267BE94ABFBC1A8AC6A17A5C28',
          'versionName': '2021-医院渠道',
          'versionNameSub': '2021-医院渠道-Q2',
          'year': '2021',
          'channel': '医院渠道',
          'channelId': '0480436ACDA54134B4B55F6AEB20F6B5',
          'position': '医药代表',
          'positionId': 'D5A7841B964C46F4812A5FEF043A8326',
          'quarter': 'Q2',
          'kpi': '行为管理评级',
          'kpiWeight': '40.0',
          'kpiType': 'Common',
          'isCondition': null,
          'uploadState': null,
          'updateTime': '2021-09-10T13:36:06.063',
          'updateUser': '吴章强',
          'createTime': '2021-09-02T20:13:18.06',
          'createUser': '吴章强',
          'deployState': null,
          'kpiId': null,
          'kpiAchCondition': null
        },
        {
          'id': 'BF5C854A2A7B4833ABC584E13817AF4D',
          'versionName': '2021-医院渠道',
          'versionNameSub': '2021-医院渠道-Q1',
          'year': '2021',
          'channel': '医院渠道',
          'channelId': '0480436ACDA54134B4B55F6AEB20F6B5',
          'position': '医药代表',
          'positionId': 'D5A7841B964C46F4812A5FEF043A8326',
          'quarter': 'Q1',
          'kpi': 'HT质量评级',
          'kpiWeight': '20.0',
          'kpiType': 'Common',
          'isCondition': null,
          'uploadState': null,
          'updateTime': '2021-09-10T13:36:06.063',
          'updateUser': '吴章强',
          'createTime': '2021-09-02T20:13:18.043',
          'createUser': '吴章强',
          'deployState': null,
          'kpiId': null,
          'kpiAchCondition': null
        },
        {
          'id': 'D4BF61E3AF704E1AB451FBD39DB19A99',
          'versionName': '2021-医院渠道',
          'versionNameSub': '2021-医院渠道-Q2',
          'year': '2021',
          'channel': '医院渠道',
          'channelId': '0480436ACDA54134B4B55F6AEB20F6B5',
          'position': '医药代表',
          'positionId': 'D5A7841B964C46F4812A5FEF043A8326',
          'quarter': 'Q2',
          'kpi': 'HT数量评级',
          'kpiWeight': '20.0',
          'kpiType': 'Common',
          'isCondition': null,
          'uploadState': null,
          'updateTime': '2021-09-10T13:36:06.063',
          'updateUser': '吴章强',
          'createTime': '2021-09-02T20:13:18.057',
          'createUser': '吴章强',
          'deployState': null,
          'kpiId': null,
          'kpiAchCondition': null
        },
        {
          'id': 'E3D00AD716CF48B0BCA31280BA6AB00E',
          'versionName': '2021-医院渠道',
          'versionNameSub': '2021-医院渠道-Q1',
          'year': '2021',
          'channel': '医院渠道',
          'channelId': '0480436ACDA54134B4B55F6AEB20F6B5',
          'position': '医药代表',
          'positionId': 'D5A7841B964C46F4812A5FEF043A8326',
          'quarter': 'Q1',
          'kpi': 'HT数量评级',
          'kpiWeight': '20.0',
          'kpiType': 'Common',
          'isCondition': null,
          'uploadState': null,
          'updateTime': '2021-09-10T13:36:06.063',
          'updateUser': '吴章强',
          'createTime': '2021-09-02T20:13:18.04',
          'createUser': '吴章强',
          'deployState': null,
          'kpiId': null,
          'kpiAchCondition': null
        }
      ]
    }
  },
  created () {},
  mounted () {
    this.getCommonData(this.arr1, this.arr2)
    this.getCommonData1(this.arr1, this.arr2)
    this.getCommonData2(this.arr1, this.arr2)
  },
  methods: {
    getCommonData (arr1, arr2) {
      let leng = arr1.length
      let newArr = []
      for (let i = 0; i < leng; i++) {
        let leng2 = arr2.length
        for (let j = 0; j < leng2; j++) {
          if (arr1[i].quarter === arr2[j].quarter && arr1[i].kpiType === arr2[j].kpiType && arr1[i].kpi === arr2[j].kpi) {
            newArr.push(arr2[j])
          }
        }
      }
      // console.log(newArr)
    },
    getCommonData1 (arr1, arr2) {
      let newArr = []
      arr1.forEach(e1 => {
        arr2.forEach(e2 => {
          if (e1.quarter === e2.quarter && e1.kpiType === e2.kpiType && e1.kpi === e2.kpi) {
            newArr.push(e2)
          }
        })
      })
      // console.log(newArr)
    },
    getCommonData2 (arr1, arr2) {
      let newArr = []
      let isExist = false
      for (let i = 0; i < arr1.length; i++) {
        for (let j = 0; j < arr2.length; j++) {
          if (arr1[i].quarter === arr2[j].quarter && arr1[i].kpiType === arr2[j].kpiType && arr1[i].kpi === arr2[j].kpi) {
            // console.log(arr1[i].quarter)
            isExist = true
            break
          } else {
            isExist = false
          }
        }
        // console.log(isExist)
        if (!isExist) {
          newArr.push(arr1[i])
        }
      }
      // console.log(newArr)
    }
  }
}
</script>

<style lang="less" scoped>

</style>
